import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";
import { CollectionLetterModel } from "./models";

export type GetCollectionLetterHistoryRequest = {
  addressUnitNo: string;
  addressStreetNo: string;
  addressStreetName: string;
  addressSuburbName: string;
  addressStateCode: string;
  addressPostCode: string;
  addressCountry: string;
};

export type GetCollectionIssueHistoryResponse = {
  letters: CollectionLetterModel[];
};

export const getCollectionLetterHistory = async (request: GetCollectionLetterHistoryRequest) => {
  const response = await executeApiRequest(
    () => axios.get<GetCollectionIssueHistoryResponse>(`/letterhistory`, { params: request }),
    false
  );

  return response?.data.letters;
};
